import React from 'react';
export function RefundsContent() {
  return <div className="prose prose-lg max-w-none text-[#5a5a5a] space-y-6" data-id="element-134">
      <p className="text-sm text-[#8b6f6f]" data-id="element-135">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <section data-id="element-136">
        <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-137">
          Garantía de Satisfacción
        </h2>
        <p data-id="element-138">
          Ofrecemos una garantía de satisfacción de 7 días. Si no está
          satisfecho con su compra, puede solicitar un reembolso completo.
        </p>
      </section>

      <section data-id="element-139">
        <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-140">
          Proceso de Reembolso
        </h2>
        <p data-id="element-141">
          Para solicitar un reembolso, contacte a nuestro equipo de soporte
          dentro de los 7 días posteriores a la compra.
        </p>
      </section>
    </div>;
}